<style lang="less" scoped>
  @import "../vars.less";

  .range-picker {}
  .range-picker-label {
    padding-top: 4px;
  }
  .left {
    text-align: left;
  }
  .center {
    text-align: center;
  }
  .right {
    text-align: right;
  }
  .value-container {
    display: inline-flex;
  }
  .from,
  .to {
    flex: auto;
    .placeholder {
      color: @text-color-third;
    }
  }
  .text {
    flex: none;
    margin: 0 @space-medium;
    color: @text-color;
  }
  .from, .to, .text {
    text-align: center;
  }
</style>

<template>
  <div class="range-picker van-cell van-field">
    <div class="van-cell__title van-field__label range-picker-label" :style="{
      width: labelWidth
    }">
      <span>{{ label }}</span>
    </div>
    <div class="van-cell__value van-field__value">
      <div class="value-container">
        <span class="from" @click="() => showStartPicker = true">
          <span class="placeholder" v-show="!value.from">{{ placeholders.from }}</span>
          <span>{{ from }}</span>
        </span>
        <span class="text">{{ $t('到') }}</span>
        <span class="to" @click="() => showEndPicker = true">
          <span v-show="!value.to">{{ placeholders.to }}</span>
          <span>{{ to }}</span>
        </span>
      </div>
    </div>
    <van-popup v-model="showStartPicker" position="bottom"
      :get-container="getContainer">
      <van-datetime-picker
        :type="type"
        :max-date="localValue.to || undefined"
        :max-hour="isSameDay ? localValue.to.getHours() : undefined"
        :max-minute="isSameHour ? localValue.to.getMinutes() : undefined"
        @confirm="onStartConfirm"
        @cancel="showStartPicker = false"
      />
    </van-popup>
    <van-popup v-model="showEndPicker" position="bottom"
      :get-container="getContainer">
      <van-datetime-picker
        :type="type"
        :min-date="localValue.from || undefined"
        :min-hour="isSameDay ? localValue.from.getHours() : undefined"
        :min-minute="isSameHour ? localValue.from.getMinutes() : undefined"
        @confirm="onEndConfirm"
        @cancel="showEndPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { Popup, DatetimePicker } from 'vant'
import format from '../utils/format'

export default {
  name: 'range-picker',
  components: {
    'van-popup': Popup,
    'van-datetime-picker': DatetimePicker
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    labelWidth: {
      type: String,
      default: ''
    },
    inputAlign: {
      type: String,
      default: 'left' // 'right' / 'center'
    },
    value: {
      type: Object,
      default () {
        return {
          from: '',
          to: ''
        }
      }
    },
    placeholders: {
      type: Object,
      default () {
        return {
          from: this.$t('开始时间'),
          to: this.$t('结束时间')
        }
      }
    },
    type: {
      type: String,
      default: 'date' // 'time', 'datetime'
    }
  },
  data () {
    return {
      localValue: this.value,
      showStartPicker: false,
      showEndPicker: false
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  computed: {
    from () {
      if (this.value.from) {
        return format(this.value.from, this.type)
      } else return null
    },
    to () {
      if (this.value.to) {
        return format(this.value.to, this.type)
      } else return null
    },
    isSameDay () {
      if (!this.localValue.from || !this.localValue.to) return false
      return format(this.localValue.from) === format(this.localValue.to)
    },
    isSameHour () {
      if (!this.isSameDay) {
        return false
      } else {
        if (!this.localValue.from || !this.localValue.to) return false
        else {
          return this.localValue.from.getHours() === this.localValue.to.getHours()
        }
      }
    }
  },
  watch: {
    value: {
      deep: true,
      handler (v) {
        if (v.from !== this.localValue.from) {
          this.localValue.from = v.from
        }
        if (!v.from) this.localValue.from = ''

        if (v.to !== this.localValue.to) {
          this.localValue.to = v.to
        }
        if (!v.to) this.localValue.to = ''
      }
    },
    localValue: {
      deep: true,
      handler (v) {
        if (
          !this.value || !this.value.from || !this.value.to ||
          this.value.from.getTime() !== v.from.getTime() ||
          this.value.to.getTime() !== v.to.getTime()
        ) {
          this.$emit('change', { ...v })
        }
      }
    }
  },
  methods: {
    onStartConfirm (value) {
      this.localValue.from = value
      this.showStartPicker = false
    },
    onEndConfirm (value) {
      this.localValue.to = value
      this.showEndPicker = false
    },
    getContainer () {
      return window.document.body
    }
  }
}
</script>
